export const MIN_RESULTS_FOR_FOOTER_TEXT = 4;
